import React from 'react';
import PropTypes from 'prop-types';

export function onStartEdit(row, column, rowIndex, columnIndex, tableData) {
	const { searchRef, keyField, editSearchMode, unhideInProgress, hideIgnoreColumns = [], inPreview = false } = this.state;
	let { hiddenRows } = this.state;
	const data = tableData ?? this.props.data;

	if (inPreview) {
		return;
	}

	if (data.length === 1) {
		return;
	}

	if (hideIgnoreColumns.some(item => item === columnIndex)) {
		return;
	}

	if (unhideInProgress) {
		this.setState({ unhideInProgress: false });
		return;
	}

	if (editSearchMode && this[searchRef].state.value) {
		return;
	}

	if (hiddenRows.length > 0) {
		return;
	}

	hiddenRows = rowsToHideOnEdit(data, keyField, rowIndex);
	this.setState({ hiddenRows });
	return true;
}

export function getUpdateRowEdit(searchText) {
	let { hiddenRows, editSearchMode } = this.state;
	let updateRowEdit = searchText || editSearchMode ? { hiddenRows: [], unhideInProgress: false } : {};

	if (searchText && hiddenRows.length > 0) {
		updateRowEdit = { ...updateRowEdit, ...{ editSearchMode: true } };
	}

	if (!searchText && editSearchMode) {
		updateRowEdit = { ...updateRowEdit, ...{ editSearchMode: false } };
	}
	return updateRowEdit;
}

export function unhideRows() {
	this.setState({ hiddenRows: [], unhideInProgress: true, editSearchMode: false });
}

export function showRows() {
	this.setState({ hiddenRows: [], unhideInProgress: false, editSearchMode: false });
}

export function setUnhideStatus() {
	const { unhideInProgress } = this.state;
	if (unhideInProgress) {
		this.setState({ unhideInProgress: false });
	}
}

export function rowsToHideOnEdit(data, keyField, editIndex) {
	if (editIndex >= data.length) {
		return [];
	}
	return data.map((item, index) => (index !== editIndex ? item[keyField] : null)).filter(item => item !== null);
}

export function areRowsHidden() {
	const { hiddenRows } = this.state;
	return hiddenRows.length > 0;
}

const editState = {
	hiddenRows: [],
	unhideInProgress: false,
	editSearchMode: false,
	searchRef: 'searchComponentRef',
	hideIgnoreColumns: []
};

export const getEditState = options => ({ ...editState, ...options });

export const AmendmentInfo = ({ count }) => {
	if (count === 0) {
		return <div className="alert alert-primary" role="alert">No Amendments</div>;
	}

	const message = `Amendment${count > 1 ? 's' : ''} made (${count})`;
	return <div className="alert alert-success" role="alert">{message}</div>;
};
AmendmentInfo.propTypes = {
	count: PropTypes.number.isRequired
};

export const UnhideButton = ({ onClick, numberOfUpdates, inButtonSet, className = '' }) => (
	<button onClick={onClick} className={`btn btn-primary btn btn-lg ${numberOfUpdates === 0 && !inButtonSet ? 'no-updates-hidden' : ''} ${className}`}>
		Unhide
	</button>
);

UnhideButton.propTypes = {
	numberOfUpdates: PropTypes.number.isRequired,
	onClick: PropTypes.func.isRequired,
	inButtonSet: PropTypes.bool,
	className: PropTypes.string
};
